const initialValues = {
  role: 2,
  name: '',
  status: 1,
};

export default initialValues;
